import type {RemediationType, TrackEventName} from "@ri2/db/client"

import {trackEvent} from "./trackEvent"

const REMEDIATION_TO_OUTCOME: Record<RemediationType, TrackEventName> = {
  diyRemediation: "chat_outcome_diy",
  difmRemediation: "chat_outcome_pro_repair",
  replaceRemediation: "chat_outcome_replace",
}

export const remediationTypeToOutcomeEvent = (
  type: RemediationType,
): TrackEventName => REMEDIATION_TO_OUTCOME[type]

export const buildOutcomeTrackingKey = (
  caseId: string,
  causeOnMessageId: number | "peek",
  type: RemediationType,
): string => `${caseId}:${causeOnMessageId}:${type}`

const trackedOutcomeKeys = new Set<string>()

export const trackRecommendationOutcome = (
  caseId: string,
  causeOnMessageId: number | "peek",
  type: RemediationType,
): void => {
  const key = buildOutcomeTrackingKey(caseId, causeOnMessageId, type)
  if (trackedOutcomeKeys.has(key)) return

  trackedOutcomeKeys.add(key)
  trackEvent(remediationTypeToOutcomeEvent(type), caseId)
}

export const resetOutcomeTrackingForTests = (): void => {
  trackedOutcomeKeys.clear()
}
